// apps/web/app/microgrid/lit/components/SystemDiagram.tsx
'use client';
import React from 'react';
import './styles/SystemDiagram.css'; // Import the separated stylesheet

const SystemDiagram: React.FC = () => (
  <div className="diagram" aria-label="System diagram: power, controller, LEDs, and app control">
    <svg viewBox="0 0 820 340" width="100%" height="100%" role="img">
      <defs>
        <linearGradient id="glow" x1="0" x2="1">
          <stop offset="0" stopColor="var(--neon-violet)" />
          <stop offset="1" stopColor="var(--neon-cyan)" />
        </linearGradient>
        <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <style>{`
          .box { fill: rgba(26,26,26,0.9); stroke: url(#glow); stroke-width: 2; rx: 10; }
          .label { fill: var(--text-color); font: 600 14px Poppins, system-ui; }
          .small { font: 300 12px Poppins, system-ui; fill: #bbb; }
          .arrow { fill: none; stroke: url(#glow); stroke-width: 3; stroke-linecap: round; stroke-linejoin: round; stroke-dasharray: 14 10; animation: dashShift 1.6s linear infinite; filter: url(#softGlow); }
          @keyframes dashShift { to { stroke-dashoffset: -24; } }
          .pulse { fill: url(#glow); filter: url(#softGlow); }
          @media (prefers-reduced-motion: reduce) { .arrow { animation: none; } animateMotion { display: none; } }
        `}</style>
      </defs>

      {/* Power chain */}
      <rect className="box" x="20" y="40" width="170" height="70" filter="url(#softGlow)" />
      <text className="label" x="35" y="75">120V AC</text>
      <text className="small" x="35" y="95">Breaker / GFCI</text>

      <rect className="box" x="220" y="40" width="200" height="70" filter="url(#softGlow)" />
      <text className="label" x="235" y="75">Low-Voltage Transformer</text>
      <text className="small" x="235" y="95">12–24V DC</text>

      <rect className="box" x="450" y="40" width="160" height="70" filter="url(#softGlow)" />
      <text className="label" x="465" y="75">Lighting Controller</text>
      <text className="small" x="465" y="95">Zones / Effects</text>

      <rect className="box" x="650" y="40" width="150" height="70" filter="url(#softGlow)" />
      <text className="label" x="665" y="68">LED Runs</text>
      <text className="small" x="665" y="90">Roofline • Eaves</text>

      <path id="a1" className="arrow" d="M190 75 H220" />
      <path id="a2" className="arrow" d="M420 75 H450" />
      <path id="a3" className="arrow" d="M610 75 H650" />

      <circle className="pulse" r="5">
        <animateMotion dur="1.6s" repeatCount="indefinite"><mpath xlinkHref="#a1" /></animateMotion>
      </circle>
      <circle className="pulse" r="5">
        <animateMotion dur="1.6s" repeatCount="indefinite" begin="0.2s"><mpath xlinkHref="#a2" /></animateMotion>
      </circle>
      <circle className="pulse" r="5">
        <animateMotion dur="1.6s" repeatCount="indefinite" begin="0.4s"><mpath xlinkHref="#a3" /></animateMotion>
      </circle>

      {/* Control plane */}
      <rect className="box" x="250" y="200" width="140" height="70" filter="url(#softGlow)" />
      <text className="label" x="265" y="235">Mobile App</text>
      <text className="small" x="265" y="255">Scenes • Schedules</text>

      <rect className="box" x="430" y="200" width="120" height="70" filter="url(#softGlow)" />
      <text className="label" x="450" y="235">Wi-Fi / LAN</text>

      <path id="a4" className="arrow" d="M390 235 H430" />
      <path id="a5" className="arrow" d="M490 200 L530 110" />

      <circle className="pulse" r="5">
        <animateMotion dur="1.6s" repeatCount="indefinite" begin="0.1s"><mpath xlinkHref="#a4" /></animateMotion>
      </circle>
      <circle className="pulse" r="5">
        <animateMotion dur="1.8s" repeatCount="indefinite" begin="0.3s"><mpath xlinkHref="#a5" /></animateMotion>
      </circle>
    </svg>
  </div>
);

export default SystemDiagram;